export class TotalReservationsForVenueRequestDTO {
  constructor (
    public venueId?: string,
    public dateFrom?: string,
    public dateTo?: string,
  ) {}
}
